import { render, staticRenderFns } from "./page_title.vue?vue&type=template&id=5df6dfc0&"
import script from "./page_title.vue?vue&type=script&lang=js&"
export * from "./page_title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports